/*
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

import React from 'react';
import MapsUgcOutlinedIcon from '@mui/icons-material/MapsUgcOutlined';
import { Button, Typography } from '@mui/material';
import style from './PatientEducationButton.scss?inline';
import { useCSS } from '../../../provider/CSSProvider';
import { ConfirmationEvent } from '../../../models/manualEvents/confirmationEvent';
import { confirmationEventDetails } from '../../../config/patientEducationTexts';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

interface PatientEducationButtonProps {
  label: ConfirmationEvent;
  isConfirmed: boolean;
  handleClick: () => void;
}

function PatientEducationButton({ label, isConfirmed, handleClick }: PatientEducationButtonProps) {
  useCSS(style);

  return (
    <div>
      <Button className='patient-education-button' onClick={handleClick}>
        <Typography className='patient-education-title'>{confirmationEventDetails[label].title}</Typography>
        {isConfirmed ? <CheckCircleIcon color='success' /> : <MapsUgcOutlinedIcon />}
      </Button>
    </div>
  );
}

export default PatientEducationButton;
